import shouldForwardProp from "@styled-system/should-forward-prop";
import { styled } from "styled-components";
import { space, SpaceProps } from "styled-system";

export type CardFooterProps = SpaceProps;

const CardFooter = styled.div<CardFooterProps>`
  border-top: 1px solid ${({ theme }) => theme.colors.cardBorder};
  ${space}
  background: ${({ theme }) => theme.colors.backgroundAlt};
  // background: rgba(11, 5, 8, 0.2);
  // padding-top: 60px;
`;

CardFooter.defaultProps = {
  p: "24px",
};

export default CardFooter;
